import { getStore } from '../store/Store';
import { getMLColumnHeaderDefaultWidths } from '../utils/getMLColumnHeaderDefaultWidths';
import { isFeatureEnabled } from 'owa-feature-flags';
import { getReceivedColumnMinWidth } from '../utils/getColumnMinWidth';
import getDensityModeString from 'owa-fabric-theme/lib/selectors/getDensityModeString';
import { isReadingPanePositionRight } from './readingPanePosition';
import { LV_SCROLLBAR_WIDTH, MCL_UNREAD_BAR_WIDTH } from '../mailLayoutConstants';

// This function adjusts the column widths stored in the store to account for various
// UI differences between the column header and the actual listview columns.
export default function getListViewColumnWidths(): {
    senderColumnWidth: number;
    subjectColumnWidth: number;
    receivedColumnWidth: number;
} {
    const defaultColumnWidths = getMLColumnHeaderDefaultWidths();

    let senderColumnWidth = getStore().senderColumnWidth || defaultColumnWidths.senderColumnWidth;
    let subjectColumnWidth =
        getStore().subjectColumnWidth || defaultColumnWidths.subjectColumnWidth;
    let receivedColumnWidth =
        getStore().receivedColumnWidth || defaultColumnWidths.receivedColumnWidth;

    // Adjust widths in listview to account for padding and width differences.
    if (isFeatureEnabled('tri-mlFocusSelect') && isFeatureEnabled('tri-mlColumnHeaderHover')) {
        // adjust for unread bar:
        senderColumnWidth -= MCL_UNREAD_BAR_WIDTH;
        // Width in store is calculated from the column header which will always be LV_SCROLLBAR_WIDTH greater than the size of the column in the listview.
        receivedColumnWidth -= LV_SCROLLBAR_WIDTH;
        // enforce min width for listview column
        const minReceivedWidth = getReceivedColumnMinWidth(
            false /* isColumnHeader */,
            isReadingPanePositionRight()
        );
        // Enforce min received column width in listview
        if (receivedColumnWidth < minReceivedWidth) {
            receivedColumnWidth = minReceivedWidth;
        }
    } else {
        senderColumnWidth += getDensityModeString() === 'full' ? 63 : 59;
        // remove 3 px for column spacing
        subjectColumnWidth -= 3;
    }
    return {
        senderColumnWidth,
        subjectColumnWidth,
        receivedColumnWidth,
    };
}
